import React from "react";
import { icons } from "../ui/Icon";
import SylobNavLink from "../ui/NavLink";
import useAuth from "../../hooks/useAuth";
import { UserRole } from "../../model/UserRole";

// Define the props type for the Menu component
interface MenuProps {
  isCollapsed: boolean; // Define the type for isCollapsed as boolean
}

/**
 * Représente le menu de l'application
 * NavLink permet de créer des liens vers les différentes pages, tout en
 * gardant l'information de quelle page est active
 * @param {MenuProps} props - Props for the Menu component
 * @returns
 */
type RouteType = {
  route: string;
  icon: keyof typeof icons;
  text: string;
};

function Menu({ isCollapsed }: MenuProps) {
  const auth = useAuth();
  let roles = auth.roles;
  const isAdmin = roles.includes(UserRole.ADMIN);
  const routes: RouteType[] = isAdmin
    ? [
        { route: "/home", icon: "home", text: "Home" },
        { route: "/export", icon: "process", text: "Extraction & Integration" },
        { route: "/translation", icon: "timeline", text: "Translation Phases" },
        { route: "/users", icon: "users", text: "Users" },
      ]
    : [
        { route: "/home", icon: "home", text: "Home" },
        { route: "/translation", icon: "translation", text: "Translations" },
      ];
  const centerItemsIfCollapsed = isCollapsed ? "items-center" : "";
  return (
    <>
      <nav className={`w-full flex flex-col justify-center ${centerItemsIfCollapsed} px-2`}>
        {routes.map((route, index) => (
          <React.Fragment key={index}>
            {isAdmin && route.route === "/users" && <div className="w-full border border-gray-300 mt-1 mb-3"></div>}
            <SylobNavLink
              key={index}
              route={route.route}
              icon={route.icon}
              text={route.text}
              isMenuCollapsed={isCollapsed}
            />
          </React.Fragment>
        ))}
      </nav>
    </>
  );
}

export default Menu;
